import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SkinType = lazyWithPreload(() => import('./SkinType'))
export const LikeChatSkinType = lazyWithPreload(
  () => import('./LikeChatSkinType'),
)
export const SkinTypeVariant2 = lazyWithPreload(
  () => import('./SkinTypeVariant2'),
)
